export default [
  {
    path: "/compras",
    name: "compras",
    label: "Compras",
    component: () => import("@/components/home/MenuCompras.vue"),
  },
  {
    path: "/compras/docs/nfe/importar",
    name: "compras.docs.nfe.importar",
    label: "Importar NF-e manualmente",
    component: () => import("@/components/compras/compras/importar-NFe.vue"),
  },
  {
    path: "/compras/docs/nfe/gerenciar",
    name: "compras.docs.nfe",
    label: "Visualizar Lista de NF-e",
    component: () => import("@/components/compras/compras/gerenciar-notas-importadas.vue"),
  },
  {
    path: "/compras/docs/cte/gerenciar",
    name: "compras.docs.cte",
    label: "Visualizar Lista de CT-e",
    component: () => import("@/components/logistica/cte/gerenciar-cte-importados.vue"),
  },
  {
    path: "/compras/docs/cte/importar",
    name: "compras.docs.cte.importar",
    label: "Importar CT-e manualmente",
    component: () => import("@/components/logistica/cte/importar-cte.vue"),
  },
  {
    path: "/compras/docs/cte/visualizar/:id",
    name: "compras.docs.cte.show",
    label: "Visualizar Detalhes de CT-e Importada",
    component: () => import("@/components/logistica/cte/cte-importada-show.vue"),
  },
  {
    path: "/compras/docs/nfse",
    name: "compras.docs.nfse",
    label: "Visualizar Lista de NFS-e",
    component: () => import("@/components/compras/compras/servico/gerenciar-nfse-importadas.vue"),
  },
  {
    path: "/compras/docs/duimp",
    name: "compras.docs.duimp",
    label: "Visualizar Lista de Duimp",
    component: () => import("@/components/compras/compras/duimp/manage-duimps.vue"),
  },
  {
    path: "/compras/docs/duimp/:id/produtos",
    name: "compras.docs.duimp.produtos",
    label: "Vincular Produtos da Duimp",
    component: () => import("@/components/compras/compras/duimp/link-duimp-products.vue"),
  },
  {
    path: "/compras/docs/duimp/:id/conteineres",
    name: "compras.docs.duimp.conteineres",
    label: "Alocar Contêineres da Duimp",
    component: () => import("@/components/compras/compras/duimp/allocate-duimp-containers.vue"),
  },
  {
    path: "/compras/docs/nfe/:id",
    name: "compras.docs.nfe.importada",
    label: "Visualizar Detalhes de NF-e Importadas (Comércio)",
    component: () => import("@/components/compras/compras/nota-importada.vue"),
  },
  {
    path: "/compras/docs/nfe-industria/:id",
    name: "compras.docs.nfe.importada-industria",
    label: "Visualizar Detalhes de NF-e Importadas (Indústria)",
    component: () => import("@/components/compras/compras/nota-importada-industria.vue"),
  },
  {
    path: "/compras/cadastros",
    name: "compras.cadastros",
    label: "Cadastros",
    component: () => import("@/components/compras/cadastros/home-cadastros.vue"),
  },
  {
    path: "/compras/ordem-compras",
    name: "compras.ordem-compras",
    label: "Ordens de Compra",
    component: () => import("@/components/compras/compras/SubmenuComprasOrdemCompras.vue"),
  },
  {
    path: "/compras/docs",
    name: "compras.docs",
    label: "Docs. Fiscais",
    component: () => import("@/components/compras/compras/SubmenuComprasDocsFiscais.vue"),
  },
  {
    path: "/compras/docs/manifestacao",
    name: "compras.docs.manifestacao",
    label: "Manifestação NF-e",
    component: () => import("@/components/contabilidade/docsfiscais/manifestacao.vue"),
  },
  {
    path: "/compras/cotacao",
    name: "compras.cotacao",
    label: "Cotação",
    component: () => import("@/components/compras/cotacao/home-cotacao.vue"),
  },
  {
    path: "/compras/cotacao/gerenciar",
    name: "compras.cotacao.gerenciar",
    label: "Gerenciar Cotações",
    component: () => import("@/components/compras/cotacao/gerenciar-cotacoes.vue"),
  },
  {
    path: "/compras/cotacao/nova",
    name: "compras.cotacao.nova",
    label: "Nova Cotação",
    component: () => import("@/components/compras/cotacao/nova-cotacao-v2.vue"),
  },
  {
    path: "/compras/cotacao/configuracoes",
    name: "compras.cotacao.configuracoes",
    label: "Fornecedores por Item",
    component: () => import("@/components/compras/cotacao/cotacao-configuracoes.vue"),
  },
  {
    path: "/compras/cotacao/relatorios",
    name: "compras.cotacao.relatorios",
    label: "Relatórios de Cotação",
    component: () => import("@/components/compras/cotacao/cotacao-home-relatorios.vue"),
  },
  {
    path: "/compras/cotacao/relatorios/historico",
    name: "compras.cotacao.relatorios.historico",
    label: "Histórico de Cotações",
    component: () => import("@/components/compras/cotacao/cotacao-relatorio-historico.vue"),
  },
  {
    path: "/compras/cotacao/relatorios/melhores-precos",
    name: "compras.cotacao.relatorios.melhores-precos",
    label: "Melhores Preços",
    component: () => import("@/components/compras/cotacao/cotacao-relatorio-melhores-precos.vue"),
  },
  {
    path: "/compras/cotacao/:sessao_id/editar",
    name: "compras.cotacao.editar",
    label: "Editar Cotação",
    component: () => import("@/components/compras/cotacao/nova-cotacao-v2.vue"),
  },
  {
    path: "/compras/cotacao/:sessao_id",
    name: "compras.cotacao.detalhes",
    label: "Detalhes da Cotação",
    component: () => import("@/components/compras/cotacao/cotacao-detalhes.vue"),
  },
  {
    path: "/compras/cadastros/fornecedores/cadastro",
    name: "compras.cadastros.fornecedores.novo",
    label: "Cadastrar Fornecedores",
    component: () => import("@/components/compras/cadastros/fornecedor/form-fornecedor.vue"),
  },
  {
    path: "/compras/cadastros/fornecedores/editar/:id",
    name: "compras.cadastros.fornecedores.editar",
    label: "Editar Fornecedores",
    component: () => import("@/components/compras/cadastros/fornecedor/form-fornecedor.vue"),
  },
  {
    path: "/compras/cadastros/fornecedores",
    name: "compras.cadastros.fornecedores",
    label: "Visualizar Lista de Fornecedores",
    component: () => import("@/components/compras/cadastros/fornecedor/fornecedores.vue"),
  },
  {
    path: "/compras/cadastros/categorias-fornecedor",
    name: "compras.cadastros.categorias-fornecedor",
    label: "Categorias de Fornecedor",
    component: () => import("@/components/compras/cadastros/fornecedor/categorias-fornecedor.vue"),
  },
  {
    path: "/compras/pendencias",
    name: "compras.pendencias",
    label: "Pendências de Recebimento",
    component: () => import("@/components/compras/pendencias/ListaPendencias.vue"),
  },
  {
    path: "/compras/pendencias/nova",
    name: "compras.pendencias.nova",
    label: "Nova Pendência",
    component: () => import("@/components/compras/pendencias/NovaPendencia.vue"),
    meta: { permission: "compras.pendencias.criar" },
  },
  {
    path: "/compras/pendencias/configuracoes",
    name: "compras.pendencias.configuracoes",
    label: "Configurações de Pendências",
    component: () => import("@/components/compras/pendencias/ConfiguracoesPendencias.vue"),
    meta: { permission: "compras.pendencias" },
  },
  {
    path: "/compras/pendencias/:id",
    name: "compras.pendencias.show",
    label: "Detalhe da Pendência",
    component: () => import("@/components/compras/pendencias/DetalhePendencia.vue"),
    meta: { permission: "compras.pendencias" },
  },
  {
    path: "/compras/relatorios",
    name: "compras.relatorios",
    label: "Relatórios",
    component: () => import("@/components/compras/relatorios/home-relatorios.vue"),
  },
  {
    path: "/compras/relatorios/pendencias",
    name: "compras.relatorios.pendencias",
    label: "Indicadores de Pendências",
    component: () => import("@/components/compras/pendencias/RelatorioPendencias.vue"),
    meta: { permission: "compras.pendencias.relatorios" },
  },
  {
    path: "/compras/cotacao/mat/:CodMatPri",
    name: "compras.cotacao.materia-prima.novo",
    label: "Criar Cotação de Insumos",
    component: () => import("@/components/compras/cotacao/nova-cotacao.vue"),
  },
  {
    path: "/compras/cotacao/pro/:CodPro",
    name: "compras.cotacao.produtos.novo",
    label: "Criar Cotação de Produtos",
    component: () => import("@/components/compras/cotacao/nova-cotacao.vue"),
  },
  {
    path: "/compras/cotacao/materia-prima",
    name: "compras.cotacao.materia-prima",
    label: "Visualizar Lista de Cotação de Insumos",
    component: () => import("@/components/compras/cotacao/cotacao.vue"),
  },
  {
    path: "/compras/cotacao/produtos",
    name: "compras.cotacao.produtos",
    label: "Visualizar Lista de Cotação de Produtos",
    component: () => import("@/components/compras/cotacao/cotacao-produtos.vue"),
  },
  {
    path: "/compras/ordem-compras/gerenciar/novo",
    name: "compras.ordem-compras.novo",
    label: "Criar Ordens de Compra",
    component: () => import("@/components/compras/compras/nova-ordem-compra.vue"),
  },
  {
    path: "/compras/ordem-compras/gerenciar/editar/:id",
    name: "compras.ordem-compras.editar",
    label: "Editar Ordem de Compra",
    component: () => import("@/components/compras/compras/nova-ordem-compra.vue"),
  },

  {
    path: "/compras/ordem-compras/gerenciar",
    name: "compras.ordem-compras.gerenciar",
    label: "Visualizar Lista de Ordens de Compra",
    component: () => import("@/components/compras/compras/gerenciar-ordem-compra.vue"),
  },
  {
    path: "/compras/ordem-compra/:id",
    name: "compras.ordem-compras.visualizar",
    label: "Visualizar Detalhes da Ordem de Compra",
    component: () => import("@/components/compras/compras/gerenciar-ordem-compra-show.vue"),
  },
  {
    path: "/compras/ordem-compras/equipe",
    name: "compras.ordem-compras.equipe",
    label: "Equipe de Compras",
    component: () => import("@/components/compras/compras/GerenciarEquipeCompras.vue"),
  },
  {
    path: "/compras/ordem-compras/alcadas",
    name: "compras.ordem-compras.alcadas",
    label: "Alçadas de Compra",
    component: () => import("@/components/compras/compras/GerenciarAlcadas.vue"),
  },
  {
    path: "/compras/ordem-compras/solicitacoes",
    name: "compras.ordem-compras.solicitacoes",
    label: "Solicitações de Compra",
    component: () => import("@/components/compras/compras/GerenciarSolicitacoes.vue"),
  },
  {
    path: "/compras/ordem-compras/solicitacoes/nova",
    name: "compras.ordem-compras.solicitacoes.nova",
    label: "Nova Solicitação de Compra",
    component: () => import("@/components/compras/compras/NovaSolicitacao.vue"),
  },
  {
    path: "/compras/ordem-compras/solicitacoes/:id/editar",
    name: "compras.ordem-compras.solicitacoes.editar",
    label: "Editar Solicitação de Compra",
    component: () => import("@/components/compras/compras/NovaSolicitacao.vue"),
  },
  {
    path: "/compras/ordem-compras/solicitacoes/:id",
    name: "compras.ordem-compras.solicitacoes.visualizar",
    label: "Visualizar Solicitação de Compra",
    component: () => import("@/components/compras/compras/VisualizarSolicitacao.vue"),
  },
  {
    path: "/compras/relatorios/ressuprimento",
    name: "compras.relatorios.ressuprimento",
    label: "Relatório de Ressuprimento",
    component: () => import("@/components/compras/relatorios/ressuprimento.vue"),
  },
  {
    path: "/compras/relatorios/notas-importadas-planos-contas",
    name: "compras.relatorios.notas-importadas-planos-contas",
    label: "Relatório de Notas Importadas por Plano de Contas",
    component: () => import("@/components/compras/relatorios/importadas-planos-contas.vue"),
  },
  {
    path: "/compras/relatorios/ressuprimento-estoque",
    name: "compras.relatorios.ressuprimento-estoque",
    label: "Relatório de Ressuprimento de Estoque",
    component: () => import("@/components/compras/relatorios/ressuprimento-estoque.vue"),
  },
  {
    path: "/compras/relatorios/custo-compras",
    name: "compras.relatorios.custo-compras",
    label: "Relatório de Custo de Compras",
    component: () => import("@/components/compras/relatorios/custo-compras.vue"),
  },
  {
    path: "/compras/relatorios/rastreabilidade-compras",
    name: "compras.relatorios.rastreabilidade-compras",
    label: "Relatório de Rastreabilidade de Compras",
    component: () => import("@/components/compras/relatorios/rastreabilidade-compras.vue"),
  },
];
